
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'

function CircleCheckIcon({
  checked = false,
  trueClassName = '',
  falseClassName = '',
  trueStyle = {
    color: 'green',
  },
  falseStyle = {
    color: 'orange',
  },
}) {
  return checked ? (
    <CheckCircleOutlined className={trueClassName} style={trueStyle} />
  ) : (
    <CloseCircleOutlined className={falseClassName} style={falseStyle} />
  )
}

CircleCheckIcon.propTypes = {
  checked: PropTypes.bool,
  trueClassName: PropTypes.string,
  falseClassName: PropTypes.string,
  trueStyle: PropTypes.shape({
    fontSize: PropTypes.string,
    color: PropTypes.string,
  }),
  falseStyle: PropTypes.shape({
    fontSize: PropTypes.string,
    color: PropTypes.string,
  }),
}

export default CircleCheckIcon
